/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  DetailedFuelFilling,
  GetFuelFillingParams
} from '../../model';





/**
 * Can be used for getting fuel fillings.
 * @summary Get fuel fillings in JSON
 */
export const getFuelFilling = (
    targetId: number,
    params: GetFuelFillingParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DetailedFuelFilling[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targets/${targetId}/fuelfillings`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetFuelFillingQueryKey = (targetId?: number,
    params?: GetFuelFillingParams,) => {
    return [
    `/api/v1.1/targets/${targetId}/fuelfillings`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFuelFillingQueryOptions = <TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFuelFillingQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFuelFilling>>> = ({ signal }) => getFuelFilling(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(targetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFuelFillingQueryResult = NonNullable<Awaited<ReturnType<typeof getFuelFilling>>>
export type GetFuelFillingQueryError = AxiosError<DetailedFuelFilling[]>


export function useGetFuelFilling<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFuelFilling>>,
          TError,
          Awaited<ReturnType<typeof getFuelFilling>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFuelFilling<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFuelFilling>>,
          TError,
          Awaited<ReturnType<typeof getFuelFilling>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFuelFilling<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fuel fillings in JSON
 */

export function useGetFuelFilling<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFuelFillingQueryOptions(targetId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFuelFillingSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFuelFillingQueryKey(targetId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFuelFilling>>> = ({ signal }) => getFuelFilling(targetId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFuelFillingSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFuelFilling>>>
export type GetFuelFillingSuspenseQueryError = AxiosError<DetailedFuelFilling[]>


export function useGetFuelFillingSuspense<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFuelFillingSuspense<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFuelFillingSuspense<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get fuel fillings in JSON
 */

export function useGetFuelFillingSuspense<TData = Awaited<ReturnType<typeof getFuelFilling>>, TError = AxiosError<DetailedFuelFilling[]>>(
 targetId: number,
    params: GetFuelFillingParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFuelFilling>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFuelFillingSuspenseQueryOptions(targetId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




